<template>
  <v-layout justify-center="" style="margin-top: 10%;">
    <v-card :elevation="20" width="500" v-bind:loading="loginLoading">
      <v-card-text class="text-center">
        <h1 class="font-weight-light">Login to CSC Self Service Portal</h1>
      </v-card-text>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="username"
                  type="text"
                  name="username"
                  label="Username"
                  outlined
                  @keyup.enter.native="signIn"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="password"
                  :type="'password'"
                  name="current-password"
                  label="Password"
                  required
                  outlined
                  @keyup.enter.native="signIn"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                {{ errorMessage }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="orange"
            @click="signIn"
            x-large
            v-bind:loading="loginLoading"
            >Login
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-form>
      <v-card-text>
        <a v-on:click="forgotPassword">Forgot Password?</a>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import AuthEventBus from '../events/authEventBus'
import { Auth } from 'aws-amplify'

export default {
  name: 'SignIn',
  props: ['signInConfig', 'usernameAttributes'],
  data() {
    return {
      password: '',
      username: '',
      errorMessage: '',
      loginLoading: false
    }
  },
  computed: {
    options() {
      const defaults = {
        header: 'Sign in to your account',
        username: '',
        isSignUpDisplayed: true
      }
      return Object.assign(defaults, this.signInConfig || {})
    }
  },
  methods: {
    signIn: function(event) {
      this.loginLoading = true
      this.errorMessage = ''
      Auth.signIn(this.username, this.password)
        .then(data => {
          this.loginLoading = false
          if (
            data.challengeName === 'SMS_MFA' ||
            data.challengeName === 'SOFTWARE_TOKEN_MFA'
          ) {
            AuthEventBus.$emit('localUser', data)
            return AuthEventBus.$emit('authState', 'confirmSignIn')
          } else if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
            AuthEventBus.$emit('localUser', data)
            return AuthEventBus.$emit('authState', 'requireNewPassword')
          } else if (data.challengeName === 'MFA_SETUP') {
            AuthEventBus.$emit('localUser', data)
            return AuthEventBus.$emit('authState', 'setMfa')
          } else if (
            data.challengeName === 'CUSTOM_CHALLENGE' &&
            data.challengeParam &&
            data.challengeParam.trigger === 'true'
          ) {
            AuthEventBus.$emit('localUser', data)
            return AuthEventBus.$emit('authState', 'customConfirmSignIn')
          } else {
            return AuthEventBus.$emit('authState', 'signedIn')
          }
        })
        .catch(e => {
          this.loginLoading = false
          if (e.code && e.code === 'UserNotConfirmedException') {
            AuthEventBus.$emit('localUser', {
              username: this.username
            })
            AuthEventBus.$emit('authState', 'confirmSignUp')
          } else if (e.code && e.code === 'PasswordResetRequiredException') {
            AuthEventBus.$emit('localUser', {
              username: this.username
            })
            AuthEventBus.$emit('authState', 'requirePasswordReset')
          } else {
            this.errorMessage = 'Username or Password incorrect'
          }
        })
    },
    forgotPassword: function() {
      AuthEventBus.$emit('authState', 'forgotPassword')
    }
  }
}
</script>
